import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import LoadingStatus from '../controls/LoadingStatusContainer'
import webAuth, { requireSetup } from '../../utils/AuthService'
import * as AuthenticationActionCreators from '../../actions/authentication'

const AUTH_STATUS = {
  INITIAL: 'INITIAL',
  AUTHENTICATED: 'AUTHENTICATED',
  RESET_PASSWORD: 'RESET_PASSWORD',
  REQUIRE_SETUP: 'REQUIRE_SETUP',
  ERROR: 'ERROR',
  EXPIRED: 'EXPIRED',
}

class Callback extends React.Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  }

  static mapDispatchToProps(dispatch) {
    return {
      actions: bindActionCreators(AuthenticationActionCreators, dispatch),
    }
  }

  state = {
    authenticatedStatus: AUTH_STATUS.INITIAL,
  }

  componentDidMount() {
    const options = {}
    const isPasswordless = this.props.location.pathname === '/magiclink'

    if (isPasswordless) {
      options.state = 'blokable'
    }

    if (/access_token|id_token|error/.test(window.location.hash)) {
      webAuth.parseHash(options, (error, authResult) => {
        if (error) {
          if (this.linkExpiredError(error)) {
            this.setState({ authenticatedStatus: AUTH_STATUS.EXPIRED })
          } else {
            this.setState({ authenticatedStatus: AUTH_STATUS.ERROR })
          }
          /* error handling */
          // Error here only should happen when the person logged in
          // but somehow hash isn't valid. Probably timing issue or some sort of attack.
          // console.log(getErrorText(error))
        } else {
          this.props.actions.loginSuccess(authResult)

          if (requireSetup(authResult)) {
            this.setState({ authenticatedStatus: AUTH_STATUS.REQUIRE_SETUP })
          } else if (isPasswordless) {
            this.setState({ authenticatedStatus: AUTH_STATUS.RESET_PASSWORD })
          } else {
            this.setState({ authenticatedStatus: AUTH_STATUS.AUTHENTICATED })
          }
        }
      })
    }
  }

  linkExpiredError = (error) => (
    error.error === 'unauthorized'
    && (
      error.errorDescription === 'The verification code has expired. Please try to login again.'
      || error.errorDescription === 'Wrong email or verification code.'
      || error.errorDescription === 'You\'ve reached the maximum number of attempts. Please try to login again.'
    )
  )

  render() {
    switch (this.state.authenticatedStatus) {
      case AUTH_STATUS.EXPIRED:
        return <Redirect to={{ pathname: '/login/expired' }} />
      case AUTH_STATUS.ERROR:
        return <Redirect to={{ pathname: '/login' }} />
      case AUTH_STATUS.REQUIRE_SETUP:
        return <Redirect to={{ pathname: '/setup' }} />
      case AUTH_STATUS.RESET_PASSWORD:
        return <Redirect to={{ pathname: '/login/reset' }} />
      case AUTH_STATUS.AUTHENTICATED:
        return <Redirect to={{ pathname: '/' }} />
      default:
        return <LoadingStatus />
    }
  }
}

export default connect(Callback.mapStateToProps, Callback.mapDispatchToProps)(Callback)
